export var NetworkClassification;
(function (NetworkClassification) {
    NetworkClassification["NETWORK_CLASSIFICATION_PUBLICLY_EXPOSED"] = "PUBLICLY_EXPOSED";
    NetworkClassification["NETWORK_CLASSIFICATION_RESTRICTED_EXTERNAL"] = "RESTRICTED_EXTERNAL";
    NetworkClassification["NETWORK_CLASSIFICATION_CORPORATE_NETWORK_CONNECTED"] = "CORPORATE_NETWORK_CONNECTED";
    NetworkClassification["NETWORK_CLASSIFICATION_INTERNAL"] = "INTERNAL";
    NetworkClassification["NETWORK_CLASSIFICATION_UNKNOWN"] = "UNKNOWN";
    NetworkClassification["NETWORK_CLASSIFICATION_UNSPECIFIED"] = "NETWORK_CLASSIFICATION_UNSPECIFIED";
})(NetworkClassification || (NetworkClassification = {}));
